export type connectionState = 'Stopped' | 'Connecting' | 'Connected' | 'Disconnected' | 'Reconnecting';
